// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-tagsinput/react-tagsinput.css
// module id = 808
// module chunks = 1